module.exports = __webpack_public_path__ + "public/img/预案编制bg.992783b8.png";